<nz-modal
  [(nzVisible)]="isNewInterviewVisible"
  nzTitle="Add New Interview"
  (nzOnCancel)="handleNewInterviewCancel()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <nz-alert nzType="info" nzMessage="Each interview lasts up to 60 minutes." nzShowIcon></nz-alert>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="interviewType">
          <div class="horizontal">
            <div>Interview Type</div>
          </div>
        </nz-form-label>
        <nz-form-control nzErrorTip="Interview type required.">
          <nz-radio-group formControlName="interviewType" id="interviewType">
            <label nz-radio [nzValue]="InterviewType.normal">
              <div class="horizontal">
                <span>Normal Interview </span>
                <app-question-button [text]="normalInterviewExplain" [isMarkdown]="true"></app-question-button>
              </div>
            </label>
            <label nz-radio [nzValue]="InterviewType.code">
              <div class="horizontal">
                <span>Coding Interview </span>
                <app-question-button [text]="codingInterviewExplain" [isMarkdown]="true"></app-question-button>
              </div>
            </label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

      @if (this.validateForm.value.interviewType! === InterviewType.code) {
        <nz-form-item>
          <nz-form-label nzRequired nzFor="programmingLanguage">Programming Language</nz-form-label>
          <nz-form-control nzErrorTip="Programming language required.">
            <nz-select formControlName="programmingLanguage" id="programmingLanguage">
              @for (item of programmingLanguageList; track $index) {
                <nz-option [nzValue]="item" [nzLabel]="item"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      }

      <nz-form-item>
        <nz-form-label nzRequired nzFor="targetPosition">Target Position</nz-form-label>
        <nz-form-control nzErrorTip="Target position required.">
          <nz-select formControlName="targetPosition" id="targetPosition">
            @for (item of goalList(); track $index) {
              <nz-option
                [nzValue]="item.id"
                [nzLabel]="item.subData.position + ' @ ' + item.subData.company"
              ></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="resume">Resume</nz-form-label>
        <nz-form-control nzErrorTip="Resume required.">
          <nz-select formControlName="resume" id="resume">
            @for (item of resumeList(); track $index) {
              <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? 'No Title'"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="interviewRound">Interview Round</nz-form-label>
        <nz-form-control nzErrorTip="Interview round required.">
          <nz-select formControlName="interviewRound" id="interviewRound">
            @for (item of interviewRoundList; track $index) {
              <nz-option [nzValue]="item" [nzLabel]="item"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="language">Interview Language</nz-form-label>
        <nz-form-control nzErrorTip="Language required.">
          <nz-select nzShowSearch formControlName="language" id="language">
            @for (item of languageList; track $index) {
              <nz-option [nzValue]="item.code" [nzLabel]="item.language"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <div class="horizontal">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="creativity">
            <div class="horizontal">
              <div>Creativity</div>
              <app-question-button [text]="creativityExplain" [isMarkdown]="true"></app-question-button>
            </div>
          </nz-form-label>
          <nz-form-control nzErrorTip="Creativity required.">
            <nz-segmented
              class="fit-content"
              formControlName="creativity"
              id="creativity"
              [nzOptions]="creativityOptions"
            ></nz-segmented>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired nzFor="answerMode">
            <div class="horizontal">
              <div>Answer Mode</div>
              <app-question-button [text]="answerExplain" [isMarkdown]="true"></app-question-button>
            </div>
          </nz-form-label>
          <nz-form-control nzErrorTip="Answer mode required.">
            <nz-segmented
              class="fit-content"
              formControlName="answerMode"
              id="answerMode"
              [nzOptions]="answerModeOptions"
            ></nz-segmented>
          </nz-form-control>
        </nz-form-item>
      </div>

      <nz-form-item>
        <nz-form-label nzFor="additionalDetails">Additional Details</nz-form-label>
        <nz-form-control>
          <textarea
            formControlName="additionalDetails"
            id="additionalDetails"
            nz-input
            placeholder="The more information the AI assistant has, the better it can provide you with tailored guidance during your interview."
            [nzAutosize]="{ minRows: 3, maxRows: 5 }"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button [nzType]="'primary'" class="submit-button">Create</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
